<p-toast [baseZIndex]="11003"></p-toast>
<p-confirmdialog />
<app-header *ngIf="showHeader()"></app-header>
<router-outlet />
